import laproueImage from '../assets/projects/LaProue.png';
import verchampsImage from '../assets/projects/Verchamps.png';
import millcallImage from '../assets/projects/millCall.png';
import karonetImage from '../assets/projects/karonet.png';
import efracamImage from '../assets/projects/efracam.png';
import promillysImage from '../assets/projects/promillysCRM.png';
import estate237Homepage from '../assets/projects/estate237homepage.png';
import estate237Second from '../assets/projects/estate237second.png';
import powervoxImage from '../assets/projects/powervox cameroun.jpeg';
import kamersphereImage from '../assets/projects/kamersphere.jpeg';
import kwalomediaImage from '../assets/images/kwalomedia.jpeg';
import avexsolutionImage from '../assets/projects/avexsolution.png';
import cbcImage from '../assets/projects/cbc1.png';
import portfolioImage from '../assets/projects/portfolio.png';
import denkyImage from '../assets/projects/denky.png';
import caolyImage from '../assets/projects/caoly.png';
import kiosque237Image from '../assets/projects/kiosque237.png';

export const mainProjects = [
  {
    id: 'avexsolution',
    title: 'AvexSolution',
    context: 'Agence digitale',
    description:
      "Site vitrine d'AvexSolution, agence digitale basée à Yaoundé. Présentation du développement logiciel, de la création et de la communication digitale, et de la formation, avec portfolio de projets et prise de contact.",
    outcome: "Parcours clair pour découvrir les services de l'agence et entrer en relation.",
    image: avexsolutionImage,
    technologies: ['React.js', 'Tailwind CSS'],
    category: 'Site Web',
    links: {
      live: 'https://avexsolution.com',
    },
  },
  {
    id: 'contacts-business-center',
    title: 'Contacts Business Center',
    context: 'Plateforme entrepreneurs',
    description:
      "Plateforme des entrepreneurs en Afrique : annuaire de contacts business, boutique en ligne WhatsApp, marketplace, formations et réseau de parrainage à trois niveaux avec commissions Mobile Money.",
    outcome: 'Un seul espace pour prospecter, se former, vendre et suivre les commissions.',
    image: cbcImage,
    technologies: ['Next.js', 'Laravel', 'MySQL'],
    category: 'Application Web',
    links: {
      live: 'https://contactsbusinesscenter.com/',
    },
  },
  {
    id: 'tffm-portfolio',
    title: 'TFFM Portfolio',
    context: 'Site personnel',
    description:
      "Portfolio personnel de Talla Fossi Florent Martial, ingénieur fullstack et UI/UX designer. Les réalisations, le parcours et les compétences y sont présentés du concept au code, dans une navigation pensée comme un album de projets.",
    outcome: 'Lecture fluide des projets, du parcours et du contact, sur desktop comme sur mobile.',
    image: portfolioImage,
    technologies: ['React.js', 'GSAP', 'Framer Motion'],
    category: 'Site Web',
    links: {
      live: 'https://florentdev.avexsolution.com/',
    },
  },
  {
    id: 'denky',
    title: 'DENKY',
    context: 'Site institutionnel',
    description:
      "Site de DENKY, marque de META INVEST SA. Présentation de la transformation agroalimentaire camerounaise ancrée dans la Région de l'Ouest : la marque, l'usine de Dengou Bandenkop, les produits et l'impact local.",
    outcome: 'Parcours institutionnel clair, de la marque aux produits et au territoire.',
    image: denkyImage,
    technologies: ['Next.js', 'Tailwind CSS'],
    category: 'Site Web',
    links: {
      live: 'https://www.denky.net/',
    },
  },
  {
    id: 'caoly',
    title: "Ca'oly",
    context: 'Maison de cacao',
    description:
      "Site de Ca'oly, maison de cacao camerounaise installée à Mbankomo. De la fève à la tablette : matières premières pour l'industrie et produits gourmets, avec le terroir, la gamme et l'usine d'Africa Processing Company.",
    outcome: 'Mise en valeur du cacao camerounais, des matières premières aux produits finis.',
    image: caolyImage,
    technologies: ['Next.js'],
    category: 'Site Web',
    links: {
      live: 'https://www.caoly.net/',
    },
  },
  {
    id: 'kiosque237',
    title: 'Kiosque237',
    context: 'Kiosque de presse',
    description:
      "Kiosque des journaux en ligne du Cameroun, basé à Yaoundé. Consultation des titres du jour, filtres par maison d'édition, quotidiens, hebdos et magazines, avec comptes lecteurs et espace de soutien.",
    outcome: 'Un présentoir unique pour parcourir la presse camerounaise en ligne.',
    image: kiosque237Image,
    technologies: ['Next.js', 'NestJS', 'MongoDB'],
    category: 'Site Web',
    links: {
      live: 'https://kiosque237.com/',
    },
  },
  {
    id: 'estate237',
    title: 'Estate237',
    context: 'Plateforme immobilière',
    description:
      "Plateforme web immobilière dédiée au marché camerounais. Présentation des biens, filtrage par critères et navigation fluide pour faciliter la mise en relation entre propriétaires, agences et acquéreurs.",
    outcome: "Expérience de recherche plus rapide et plus claire pour la découverte des biens.",
    image: estate237Homepage,
    images: [estate237Homepage, estate237Second],
    technologies: ['Next.js', 'NestJS', 'MongoDB'],
    category: 'Site Web',
    links: {
      live: 'https://estate237.com/',
    },
  },
  {
    id: 'powervox-cameroun',
    title: 'PowerVox Cameroun',
    context: "Média d'actualité",
    description:
      "Plateforme média camerounaise qui couvre l'actualité nationale et africaine avec rigueur et indépendance. Rubriques Politique, Économie, Société et Santé, tribunes d'opinion, fil en continu et espace publicitaire — le média qui amplifie les voix.",
    outcome: 'Parcours éditorial fluide et mise en avant claire des articles à la une et des tribunes.',
    image: powervoxImage,
    technologies: ['Next.js', 'WordPress'],
    category: 'Site Web',
    links: {
      live: 'https://www.powervoxcameroun.com/',
    },
  },
  {
    id: 'kamersphere',
    title: 'KAMERSPHERE',
    context: "Média d'actualité",
    description:
      "Média indépendant camerounais qui décrypte chaque jour la politique, l'économie, le sport et la santé. Fil d'actualité en continu, rubriques thématiques, tendances, newsletter et module sport pour une information vérifiée et proche des lecteurs.",
    outcome: "Lecture rapide de l'essentiel de l'actualité camerounaise, du fil en continu aux articles les plus lus.",
    image: kamersphereImage,
    technologies: ['Next.js', 'WordPress'],
    category: 'Site Web',
    links: {
      live: 'https://www.kamersphere.com/',
    },
  },
  {
    id: 'lecastor',
    title: 'Le Castor',
    context: 'E-commerce',
    description:
      "Site e-commerce professionnel permettant la vente en ligne avec présentation des produits, navigation fluide, et parcours d'achat optimisé. Interface claire et responsive pensée pour améliorer la conversion.",
    outcome: "Parcours d'achat simplifié avec une interface pensée conversion sur mobile et desktop.",
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=80',
    technologies: ['React.js', 'NestJS', 'MongoDB'],
    category: 'E-commerce',
    links: {
      live: 'https://lecastor.net/',
    },
  },
  {
    id: 'promillys-crm',
    title: 'Promillys CRM',
    context: 'Application métier CRM',
    description:
      "Application CRM complète pour l'entreprise Promillys. Gestion des clients, suivi des ventes, et tableaux de bord analytiques. Interface moderne avec modules personnalisables et intégration de services tiers.",
    outcome: 'Centralisation des données client et meilleure visibilité opérationnelle pour les équipes.',
    image: promillysImage,
    technologies: ['Next.js', 'Laravel', 'MySQL', 'Tailwind CSS'],
    category: 'Application Web',
    links: {
      live: 'https://promillys-crm-frontend.vercel.app/',
    },
  },
  {
    id: 'verchamps',
    title: 'Verchamps',
    description:
      "Site web vitrine pour une ferme agricole. Présentation des produits locaux, actualités de la ferme, et système de réservation pour les visites. Interface élégante mettant en valeur les produits et l'environnement naturel.",
    image: verchampsImage,
    technologies: ['React.js', 'Tailwind CSS'],
    category: 'Site Web',
    links: {
      live: 'https://verchamps.com',
    },
  },
  {
    id: 'karonet',
    title: 'Karonet',
    description:
      "Site web professionnel pour une entreprise de services de nettoyage. Présentation des services, devis en ligne, et système de réservation. Interface claire et professionnelle mettant en avant l'expertise et la fiabilité.",
    image: karonetImage,
    technologies: ['WordPress', 'PHP', 'MySQL'],
    category: 'Site Web',
    links: {
      live: 'https://karonet-services.fr/',
    },
  },
  {
    id: 'kwalomedia',
    title: 'KWALO Media',
    description:
      "Plateforme média moderne engagée à informer, inspirer et connecter. Site d'actualité couvrant l'actualité, la culture, la technologie et les tendances africaines. Interface dynamique avec sections dédiées aux podcasts, newsletters, et actualités par continent. Design moderne et authentique mettant en valeur le contenu francophone.",
    image: kwalomediaImage,
    technologies: ['WordPress', 'PHP', 'MySQL'],
    category: 'Site Web',
    links: {
      live: 'https://kwalomedia.com/',
    },
  },
  {
    id: 'efracam',
    title: 'EFRACAM',
    description:
      "Site web institutionnel pour un élu français d'origine camerounaise. Plateforme d'information et de communication avec les citoyens, actualités, et système de contact. Design moderne reflétant l'engagement politique et culturel.",
    image: efracamImage,
    technologies: ['WordPress', 'PHP', 'MySQL'],
    category: 'Site Web',
    links: {
      live: 'https://efracam.org/',
    },
  },
  {
    id: 'laproue',
    title: 'La Proue Inc',
    description:
      "Plateforme d'offres d'emploi pour une entreprise canadienne. Interface moderne avec système de recherche avancée, filtres par catégorie et localisation, et système de candidature en ligne. Intégration d'un tableau de bord pour les recruteurs.",
    image: laproueImage,
    technologies: ['React.js', 'C#', 'Tailwind CSS'],
    category: 'Application Web',
    links: {
      live: 'https://laproueinc.com/',
    },
  },
  {
    id: 'millcall',
    title: 'Millcall',
    description:
      "Plateforme innovante intégrant l'intelligence artificielle pour l'optimisation des processus métier. Interface intuitive avec tableaux de bord personnalisés, analyses prédictives et automatisation des tâches répétitives.",
    image: millcallImage,
    technologies: ['Next.js', 'WordPress', 'OpenAI API'],
    category: 'Intelligence Artificielle',
    links: {
      live: 'https://millcall.com/',
    },
  },
];
